import { CalendarBlock } from './CalendarBlock'
import { EmptyBlock } from './components'
import type { MainCalendarLogicSlots } from '../types'
import { Time } from '@/lib/time'

interface CalendarMainItemsProps {
  items: MainCalendarLogicSlots
}

export const CalendarMainItems: React.FC<CalendarMainItemsProps> = ({
  items,
}) => {
  return (
    <>
      {items?.map((block, j) => {
        if (block !== null) {
          const starting = block.starting ? block.starting : ''
          const startingPercent = block.starting
            ? (new Time(...starting.split(':').map(s => parseFloat(s))).reduce(
                'seconds'
              ) *
                100) /
              (60 * 60 * 24)
            : 0
          const ending = block.ending ? block.ending : ''
          const endingPercent = block.ending
            ? (new Time(...ending.split(':').map(s => parseFloat(s))).reduce(
                'seconds'
              ) *
                100) /
              (60 * 60 * 24)
            : 100
          return (
            <CalendarBlock
              key={'CalendarBlock-' + j}
              width={100 - startingPercent - (100 - endingPercent)}
              left={startingPercent}
              background={block.color}
              ending={!block.next}
              starting={!block.previous}
              onClick={block.onClick}
              text={block.text}
            />
          )
        } else {
          return <EmptyBlock key={'CalendarBlock-' + j} />
        }
      })}
    </>
  )
}
